import DialogML from './DialogML';
export default (props) => {
  return <DialogML {...props} />;
};
